export default __webpack_public_path__ + "static/media/Mergers-and-Acquisitions.1fdba047.svg";